import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      management: 'Management',
      academics: 'Academics',
      achievements: 'Achievements',
      activities: 'Activities',
      rules: 'Rules & Regulations',
      news: 'News & Announcements',
      gallery: 'Gallery',
      events: 'Events',
      contact: 'Contact Us',
      studentPortal: 'Student Portal',
      parentPortal: 'Parent Portal',
      login: 'Login',
      logout: 'Logout'
    },
    home: {
      tagline: 'Education is Above All',
      welcome: 'Welcome to New St. Francis School',
      subtitle: 'Building Tomorrow\'s Leaders Today',
      studentsCount: 'Students',
      resultRate: 'Board Result',
      yearsExperience: 'Years of Excellence',
      learnMore: 'Learn More',
      applyNow: 'Apply Now'
    },
    about: {
      title: 'About Our School',
      history: 'School History',
      vision: 'Vision & Mission',
      values: 'Our Values'
    }
  },
  hi: {
    nav: {
      home: 'मुख्य पृष्ठ',
      about: 'हमारे बारे में',
      management: 'प्रबंधन',
      academics: 'शैक्षणिक',
      achievements: 'उपलब्धियाँ',
      activities: 'गतिविधियाँ',
      rules: 'नियम और विनियम',
      news: 'समाचार और घोषणाएँ',
      gallery: 'गैलरी',
      events: 'कार्यक्रम',
      contact: 'संपर्क करें',
      studentPortal: 'छात्र पोर्टल',
      parentPortal: 'अभिभावक पोर्टल',
      login: 'लॉगिन',
      logout: 'लॉगआउट'
    },
    home: {
      tagline: 'शिक्षा सर्वोपरि है',
      welcome: 'न्यू सेंट फ्रांसिस स्कूल में आपका स्वागत है',
      subtitle: 'कल के नेताओं का निर्माण आज',
      studentsCount: 'विद्यार्थी',
      resultRate: 'बोर्ड परिणाम',
      yearsExperience: 'वर्षों की उत्कृष्टता',
      learnMore: 'और जानें',
      applyNow: 'अभी आवेदन करें'
    },
    about: {
      title: 'हमारे स्कूल के बारे में',
      history: 'विद्यालय का इतिहास',
      vision: 'दृष्टि और मिशन',
      values: 'हमारे मूल्य'
    }
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};